"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NoticeBase {
}
module.exports = NoticeBase;
